"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _react2 = require("motion/react");
var _Text = _interopRequireDefault(require("../../Text"));
var _react3 = require("@emotion/react");
var _format = require("../../../utils/format");
var _Header = _interopRequireDefault(require("../../Header"));
var _dates = require("../../../utils/dates");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CalendarSmallEvent = ({
  trackingName,
  events
}) => {
  const theme = (0, _react3.useTheme)();
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const [showTooltip, setShowTooltip] = (0, _react.useState)(false);
  const handleClick = e => {
    e.stopPropagation();
    setShowTooltip(!showTooltip);
  };
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      setShowTooltip(false);
    };
    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip, ref]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InformationWrapper, {
    ref: ref,
    onClick: handleClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CalendarSmallEventBtn, {
      trackingName: trackingName,
      background: theme.primary
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.AnimatePresence, {
      children: showTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InformationBox, {
        initial: {
          opacity: 0,
          scale: 0.9
        },
        animate: {
          opacity: 1,
          scale: 1
        },
        exit: {
          opacity: 0,
          scale: 0.9
        },
        transition: {
          duration: 0.1
        },
        children: events.length > 0 && events.map((event, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.EventContent, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
            level: 5,
            children: event.title
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Div, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              size: "14px",
              children: (0, _format.getFormattedDate)(event.date, _dates.ddmmyyyy)
            }), event.dateNote && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              size: "14px",
              children: event.dateNote
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            size: "14px",
            paragraph: true,
            align: "left",
            children: event.description
          })]
        }, i))
      })
    })]
  });
};
var _default = exports.default = CalendarSmallEvent;